import * as React from "react";
import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCirclePartial = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 120 120",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 60,
		cy: 60,
		r: 45,
		fill: "none",
		stroke: "currentColor",
		strokeDasharray: "212.058 70.686",
		strokeLinecap: "round",
		strokeWidth: 12,
		transform: "rotate(-90 60 60)"
	})
});
const Memo = memo(SvgCirclePartial);
export default Memo;
